import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ChangePasswordForm from '../components/forms/ChangePasswordForm';
import OutlinedText from '../elements/OutlinedText';
import { users } from '../helpers/api';
import Loader from '../components/Loader';
import { Container, PageContainer } from './common';
import { ToastCtx } from '~/providers/ToastProvider';
import messages from '../helpers/api/messages';
import { VRPAT } from '~/config/constants';

export default function ChangePassword() {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const toast = useContext(ToastCtx);
  const ClientText = useSelector(state => state?.issuer?.app?.name);
  const issuer = useSelector(state => state?.issuer);
  const isVR = issuer.name === VRPAT;

  function redirectIfInvalidLink(e) {
    if (
      e?.messages?.find(item => item?.code === '-13' || item?.code === '-16')
    ) {
      history.push('/esqueci-minha-senha');
    }
  }

  function msgSuccessChangePassword(email) {
    return (
      <>
        Seu login {email} está pronto para uso. <strong>Atenção:</strong> sua
        nova senha também é válida para acessar o app {ClientText}.
      </>
    );
  }

  async function handleSubmit(formPayload) {
    const token = sessionStorage.getItem('pass-token');
    const payload = {
      ...formPayload,
      token,
    };

    try {
      setIsLoading(true);
      const response = await users.changePassword(payload);
      const msgKey = isVR ? 'change_password' : 'change_password_partner';
      const content = isVR
        ? msgSuccessChangePassword(payload?.email)
        : undefined;

      toast.dispatch(messages(response, msgKey, content));

      sessionStorage.removeItem('pass-token');
      history.push('/login');
    } catch (e) {
      toast.dispatch(messages(e, 'change_password'));
      redirectIfInvalidLink(e);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <PageContainer>
      <Container>
        <Loader isLoading={isLoading}>
          <ChangePasswordForm onSubmit={handleSubmit} />
        </Loader>
      </Container>
      {isVR && <OutlinedText onlyMobile>issoévr</OutlinedText>}
    </PageContainer>
  );
}
